// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const DigitalUserAccountAddress = t.struct({
    addressLine1: t.maybe(t.String),
    addressLine2: t.maybe(t.String),
    city: t.maybe(t.String),
    stateCode: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    countryCode: t.maybe(t.String)
}, {
    defaultProps: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateCode: '',
        postalCode: '',
        countryCode: ''
    },
    name: 'DigitalUserAccountAddress',
    strict: true
});
